import React, { useState, useRef, useEffect } from 'react'
import Button from 'components/button'
import Input from 'components/input'

export interface IFormValues {
  code: string
}

interface Props {
  onSubmit: (values: IFormValues) => void
}

const TwoFactorCodeForm: React.FC<Props> = ({ onSubmit }) => {
  const [submitting, setSubmitting] = useState(false)
  const [values, setValues] = useState<IFormValues>({ code: '' })
  const inputRef = useRef<HTMLInputElement>(null)

  const codeError = values.code.trim() === ''

  useEffect(() => {
    inputRef.current?.focus()
  }, [])

  const handleSubmit = async (e: React.FormEvent) => {
    // Prevent the browser’s default full-page reload
    e.preventDefault()

    if (codeError) return
    setSubmitting(true)
    try {
      onSubmit(values)
    } catch {
      /* empty */
    }
    setSubmitting(false)
  }

  return (
    <form className="w-full" onSubmit={handleSubmit}>
      <Input
        ref={inputRef}
        name="code"
        type="text"
        placeholder="The code from your authenticator device"
        autoComplete="one-time-code"
        value={values.code}
        onChange={(e) => setValues({ ...values, code: e.target.value })}
      />

      {codeError && <p className="text-red mt-2.5">The code cannot be blank</p>}

      <Button className="mt-5 w-full text-[1rem]" type="submit" disabled={codeError} isLoading={submitting}>
        Sign In
      </Button>
    </form>
  )
}

export default TwoFactorCodeForm
